var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsefullink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_495_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 0.666992,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_495_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 29.0007H12.3333C10.0278 29.0007 8.06278 28.1879 6.43833 26.5623C4.81278 24.9379 4 22.9729 4 20.6673C4 18.3618 4.81278 16.3962 6.43833 14.7707C8.06278 13.1462 10.0278 12.334 12.3333 12.334H19V15.6673H12.3333C10.9444 15.6673 9.76389 16.1534 8.79167 17.1257C7.81944 18.0979 7.33333 19.2784 7.33333 20.6673C7.33333 22.0562 7.81944 23.2368 8.79167 24.209C9.76389 25.1812 10.9444 25.6673 12.3333 25.6673H19V29.0007ZM14 22.334V19.0007H27.3333V22.334H14ZM22.3333 29.0007V25.6673H29C30.3889 25.6673 31.5694 25.1812 32.5417 24.209C33.5139 23.2368 34 22.0562 34 20.6673C34 19.2784 33.5139 18.0979 32.5417 17.1257C31.5694 16.1534 30.3889 15.6673 29 15.6673H22.3333V12.334H29C31.3056 12.334 33.2711 13.1462 34.8967 14.7707C36.5211 16.3962 37.3333 18.3618 37.3333 20.6673C37.3333 22.9729 36.5211 24.9379 34.8967 26.5623C33.2711 28.1879 31.3056 29.0007 29 29.0007H22.3333Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsefullink);
export default __webpack_public_path__ + "static/media/Usefullink.14c5523ba6675bde03067b86febec6f4.svg";
export { ForwardRef as ReactComponent };